<template>
  <div>
    <div class="vx-row" v-show="licences.length">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <h2 class="text-center">Leia Todo Texto Abaixo com Atenção</h2>
          <p
            class="mt-4"
          >Escolha a licença que deseja transferir e em seguida digite o e-mail para qual deseja transferir a licença e confirme.</p>
          <p class="mt-4">A conta para qual deseja transferir a licença precisa existir.</p>
          <p
            class="mt-4"
          >Não é possível transferir uma licença comprada com assinatura (plano VIP). Neste caso você tem 2 opções, transferir o dispositivo da outra conta para esta conta ou cancelar a assinatura e adquirir uma nova com essa conta.</p>
          <p class="mt-4 text-danger">
            <strong>ATENÇÃO: Essa ação é irreversível. Uma vez confirmado que deseja transferir a licença para o e-mail informado a licença será removida da sua conta e estará disponível na nova conta.</strong>
          </p>
          <p class="mt-4">Qualquer dúvida entre em contato com o suporte.</p>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <h2 class="text-center mb-4">Lista de Licenças Disponíveis</h2>
          <form @submit="salvar">
            <vs-table ref="table" :data="licences" class="mb-4">
              <template slot="thead">
                <vs-th class="text-center">Selecione</vs-th>
                <vs-th>Validade</vs-th>
                <vs-th>Tipo</vs-th>
                <vs-th class="text-nowrap">Adquirida Em</vs-th>
              </template>

              <template>
                <vs-tr :data="licence" :key="index" v-for="(licence, index) in licences">
                  <vs-td valign="top" class="text-center">
                    <vs-radio v-model="licenceIdSelected" :vs-value="licence.id" :disabled="licence.subscription_id"></vs-radio>
                  </vs-td>
                  <vs-td valign="top" class="text-nowrap">
                    <span v-if="licence.months == 1">1 Mês</span>
                    <span v-else-if="licence.months > 1">{{licence.months}} Meses</span>
                    <span v-else-if="licence.days == 1">1 Dia</span>
                    <span v-else>{{licence.days}} Dias</span>
                  </vs-td>
                  <vs-td valign="top" class="text-nowrap">
                    <div v-if="licence.product.type === 'MOBILE'">Celular</div>
                    <div v-else>Desktop Cloud</div>
                  </vs-td>
                  <vs-td valign="top">
                    <span>{{licence.date_added | formatDateTime}}</span>
                    <div class="text-danger" v-if="licence.subscription_id">Licença vinculada à uma assinatura, impossível transferir.</div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="mb-4">
              <h4 class="mb-4">Para qual e-mail você quer transferir a licença?</h4>
              <div class="mb-2">
                <div>E-mail de destino</div>
                <div>
                  <vs-input class="inputx w-full text-lowercase" type="email" placeholder="E-mail de destino" v-model="email" />
                </div>
              </div>
              <div class="mb-2">
                <div>Confirmar e-mail de destino</div>
                <div>
                  <vs-input class="inputx w-full text-lowercase" type="email" placeholder="Confirmar e-mail de destino" v-model="emailConfirmation" />
                </div>
              </div>
            </div>

            <vs-checkbox v-model="confirmation" class="mb-3 mt-4">Confirmo ter lido os termos.</vs-checkbox>

            <div class="mx-4 my-4">
              <ul>
                <li class="text-danger" v-if="!licenceIdSelected">- Selecione uma licença.</li>
                <li class="text-danger" v-if="!email">- Digite o e-mail de destino.</li>
                <li class="text-danger" v-if="!emailConfirmation">- Digite a confirmação do e-mail de destino.</li>
                <li class="text-danger" v-if="email && emailConfirmation && email != emailConfirmation">- A confirmação do e-mail de destino não está correta.</li>
              </ul>
            </div>

            <vs-button
              class="w-full md:w-auto mt-4 mr-4"
              @click="salvar"
              :disabled="!confirmation || !licenceIdSelected || !email || email != emailConfirmation"
            >
              <i class="far fa-save"></i> Transferir Licença
            </vs-button>

            <vs-button color="danger" type="border" class="w-full md:w-auto mt-4" to="/dispositivo">
              <i class="far fa-times"></i> Cancelar
            </vs-button>
            <button type="submit" style="display: none"></button>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      confirmation: false,
      email: "",
      emailConfirmation: "",
      licences: [],
      licenceIdSelected: "",
    };
  },
  mounted: function () {
    this.$api
      .get("/api/v1/licence/list")
      .then((response) => {
        this.licences = response.data;
        if (!this.licences.length) {
          this.$router.push("/dispositivo");

          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: "Você não possui nenhuma licença.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      })
      .catch(() => {});
  },
  methods: {
    salvar: function () {
      this.$api
        .post("/api/v1/licence/transfer", {
          email: this.email,
          emailConfirmation: this.emailConfirmation,
          licence: this.licenceIdSelected,
        })
        .then(() => {
          this.$router.push("/dispositivo");
          this.$vs.notify({
            time: 6000,
            text: "Licença Transferida com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
